import Person from "@mui/icons-material/Person";
import { Box, Collapse, Grid, MenuItem, TextField } from "@mui/material";
import { allCountries } from "country-telephone-data";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from "react-router-dom";
import ExpandBox from "../components/ExpandBox";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
const DoctorDetail = () => {
  const [isLoader, setIsLoader] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();
  const { doctorId, doctorName, docMobile, username,clinicName } = location.state || {}; // Destructure state data

  const token = localStorage.getItem("token");
 
  // Select the react-datepicker-wrapper class
  const datePickerWrapper = document.querySelector(".react-datepicker-wrapper");
   
  if (datePickerWrapper) {
    // Set the width to 100%
    datePickerWrapper.style.width = "100%";
  }

  const [openSections, setOpenSections] = useState({
    docDetails: true,
    
  });

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const [doctorDetails, setDoctorDetails] = useState({
    name: "",
    countryCode: "",
    mobile: "",
    gender: "",
  });
  
  const getDoctorDetails = async (doctorId) => {
    try {
      setIsLoader(true);
      const details = await apiService.fetchDoctorDetails(doctorId, token);
      console.log("*************API Response: ", details);

    
      setDoctorDetails({
        name: details.name,
        mobile: details.mobile,
        countryCode: details.countryCode || "NA",
        gender: details.gender || "NA",
      });
 
    } catch (error) {
      console.error("Error in getDoctorDetails: ", error);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (doctorId) {
      getDoctorDetails(doctorId);
    }
  }, [doctorId]);

  return (
    <div>
      <Box sx={{ padding: isMobile ? 2 : 4 }}>
        <Title icon={<Person />} text={doctorName || "Doctor Details"} />

        {/* Doctor Details */}
        <ExpandBox
          title="Doctor Details"
          isOpen={openSections.docDetails}
          toggle={() => toggleSection("docDetails")}
        >
          <Collapse in={openSections.docDetails}>
            {/* Row 1: Name + Gender */}

            <Grid container spacing={2} sx={{ mb: 2, mt: 1, display: "flex" }}>
              <Grid sx={{ flex: 1 }}>
                <TextField
                  label="Name"
                  name="name"
                  value={doctorDetails.name}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid sx={{ flex: 1 }}>
                <TextField
                  select
                  label="Gender"
                  name="gender"
                  value={doctorDetails.gender}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                  SelectProps={{
                    IconComponent: () => null, // removes dropdown icon
                  }}
                >
                  {[
                    { code: "male", label: "Male" },
                    { code: "female", label: "Female" },
                  ].map((option) => (
                    <MenuItem key={option.code} value={option.code}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mb: 2, mt: 1, display: "flex" }}>
              <Grid>
                <TextField
                  select
                  label="Country Code"
                  name="countryCode"
                  value={doctorDetails.countryCode}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                  SelectProps={{
                    IconComponent: () => null, // removes dropdown icon
                  }}
                >
                  {allCountries.map((country) => (
                    <MenuItem
                      key={country.dialCode + country.iso2}
                      value={`+${country.dialCode}`}
                    >
                      {country.name} (+{country.dialCode})
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid sx={{ flex: 3 }}>
                <TextField
                  label="Mobile"
                  name="mobile"
                  value={doctorDetails.mobile}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              {!isMobile && <Grid sx={{ flex: 4 }}></Grid>}
            </Grid>
          </Collapse>
        </ExpandBox>
 
 
         
      </Box>

      {isLoader && <PageLoader />}
    </div>
  );
};

export default DoctorDetail;
